import React from 'react'

const CategoryBadge = ({ category, children }) => {
  return (
    <div className='category-badge'>
      {category.name_category ? category.name_category : category.name} {typeof children === 'function' && children({ category })}
    </div>
  )
}

export default CategoryBadge
